import CONFIG from 'Config';

export const HEADER_MENU = {
  children: [
    {
      slug: 'investors',
      name: 'Why Farmland?',
      path: '/investors',
      children: [],
    },
    {
      slug: 'explore',
      name: 'Investments',
      path: '/explore',
      children: [],
    },
    {
      slug: 'farm-owners',
      name: 'For Farmers',
      path: '/resources/farm-owners',
      children: [],
    },
    {
      slug: 'resources',
      name: 'Resources',
      path: '/resources',
      children: [
        {
          slug: 'how-it-works',
          name: 'How It Works',
          path: `${CONFIG.urls.frontend}/resources/how-it-works`,
          children: [],
        },
        {
          slug: 'learn',
          name: 'Learning Center',
          path: '/learn',
          children: [],
        },
        {
          slug: 'farmland-values',
          name: 'Farm Value Tool',
          path: '/resources/farmland-values',
          children: [],
        },
        {
          slug: 'faq',
          name: 'FAQs',
          path: '/faq',
          children: [],
        },
      ],
    },
    {
      slug: 'company',
      name: 'Company',
      path: '/company',
      children: [
        {
          slug: 'about-us',
          name: 'About Us',
          path: `${CONFIG.urls.frontend}/company/about-us`,
          children: [],
        },
        {
          slug: 'our-impact',
          name: 'Our Impact',
          path: `${CONFIG.urls.frontend}/company/our-impact`,
          children: [],
        },
        {
          slug: 'contact-us',
          name: 'Contact Us',
          path: '/company/contact-us',
          children: [],
        },
        {
          slug: 'newsroom',
          name: 'Newsroom',
          path: '/newsroom',
          children: [],
        },
        {
          slug: 'careers',
          name: 'Careers',
          path: 'https://acretrader-inc.rippling-ats.com/',
          children: [],
        },
      ],
    },
  ],
};

export const FOOTER_MENU = {
  children: [
    {
      name: 'Careers',
      path: 'https://acretrader-inc.rippling-ats.com/',
      slug: 'careers',
    },
    {
      name: 'Affiliates',
      path: 'https://affiliate.acretrader.com/',
      slug: 'affiliates',
    },
    {
      name: 'Terms of Use',
      path: '/company/terms',
      slug: 'terms-conditions',
    },
    {
      name: 'Privacy Policy',
      path: '/company/privacy',
      slug: 'privacy-policy',
    },
    {
      name: 'Contact Us',
      path: '/company/contact-us',
      slug: 'contact-us',
    },
  ],
};

export const PROFILE_MENU = [
  {
    name: 'Accounts',
    path: '/profile/accounts',
    slug: 'accounts',
  },
  {
    name: 'Investments',
    path: '/profile/investments',
    slug: 'investments',
  },
  {
    name: 'Wallet',
    path: '/profile/wallet',
    slug: 'wallet',
  },
  {
    name: 'Notifications',
    path: '/profile/notifications',
    slug: 'notifications',
  },
  {
    name: 'Settings',
    path: '/profile/settings',
    slug: 'settings',
  },
];
